(() => {
'use strict';
const init = (root = document) => {
  root.querySelectorAll('[data-menu]').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
  });
  root.querySelectorAll('[data-product-root]').forEach(product => {
    if (product.dataset.ready) return;
    product.dataset.ready = 'true';
    const select = product.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = product.querySelector('[data-product-price]');
      const button = product.querySelector('[data-add-button]');
      if (price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      }
      const quantity = product.querySelector('input[name="quantity"]');
      if (quantity) {
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });
};
const openHash = () => {
  if (!location.hash) return;
  let target;
  try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
  if (target && target.tagName === 'DETAILS') target.open = true;
};
init(); openHash();
window.addEventListener('hashchange', openHash);
document.addEventListener('shopify:section:load', event => init(event.target));
})();
